var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisconnectButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "callHangupIcon",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18,10.8c0-0.5,0-1,0-1.5c0-1.1-0.7-2-1.7-2.3c-2.4-0.8-4.9-1.2-7.4-1.2c-2.4,0-4.7,0.4-7,1.1 C0.7,7.3,0,8.2,0,9.4l0,1.4v0.7V12v0.2v0h6v-0.8v-0.6h0c0-0.3,0-0.5,0-0.8c0-0.1,0-0.1,0.1-0.2c2-0.5,3.9-0.5,5.9,0 c0.1,0,0.1,0.1,0.1,0.2c0,0.5,0,0.9,0,1.4v0.9H18L18,10.8L18,10.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectButton);
export default __webpack_public_path__ + "static/media/disconnectButton.7a4326e60bcd31f87ea1b6f8cf721cae.svg";
export { ForwardRef as ReactComponent };